module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/sales-be31fa16.png";